import React from 'react';
import { ReactComponent as PlayIcon } from '../assets/icons/reproducir.svg';
import { ReactComponent as PauseIcon } from '../assets/icons/pausar.svg';
import { ReactComponent as VolumeIcon } from '../assets/icons/volumen.svg';
import { ReactComponent as MuteIcon } from '../assets/icons/silenciar-volumen.svg';
import { ReactComponent as ExpandIcon } from '../assets/icons/expandir.svg';
import '../index.css';
import '../App.css';

const VideoControls = ({
  isPlaying,
  onPlayPause,
  isMuted,
  onMuteToggle,
  volume,
  onVolumeChange,
  onFullScreen,
  disableButtons,
  isVisible = true
}) => {
  if (!isVisible) return null;

  return (
    <div className="controles-en-tv">
      {/* Sección izquierda - solo play/pause */}
      <div className="seccion-izquierda">
        <button onClick={onPlayPause} disabled={disableButtons}>
          {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </button>
      </div>

      {/* Sección centro - VACÍA (botón apretame ahora está separado) */}
      <div className="seccion-centro">
        {/* Espacio reservado para mantener el layout */}
      </div>

      {/* Sección derecha - volumen y pantalla completa */}
      <div className="seccion-derecha">
        <button onClick={onMuteToggle} disabled={disableButtons}>
          {isMuted ? <MuteIcon /> : <VolumeIcon />}
        </button>

        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={(e) => onVolumeChange(parseFloat(e.target.value))}
          disabled={disableButtons}
        />

        <button onClick={onFullScreen} disabled={disableButtons}>
          <ExpandIcon />
        </button>
      </div>
    </div>
  );
};

export default VideoControls;